import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Gestionloyers from "./app/loyers/Gestionloyers";

import "./i18n";
import { UserProvider } from "./UserContext";
import store from "./app/store";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/">
      {/* adapte le basename selon ton déploiement  <BrowserRouter basename="/Nadine_Braiding">*/}
      <UserProvider>
        <Gestionloyers />
      </UserProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
);
